<template>
  <button role="button" aria-label="Abrir Menu Lateral" @click="handleSideBar" v-if="isSmallScreen && !sideBarActive"
    class="menu-icon bg-transparent border-0 position-absolute rounded-2 z-3">
    <i :style="{ color: userConfig?.settings.primary_color }" class="bi bi-list fs-3"></i>
  </button>

  <transition :name="isSmallScreen ? 'slide' : ''">
    <aside role="list" aria-label="Menu Lateral" v-if="sideBarActive" class="side-bar z-3" :style="{
      width: getSideBarBackGroundWidth(),
      position: isSmallScreen ? 'fixed' : 'relative',
    }">
      <div class="side-bar-content d-flex flex-column" :style="{
        width: getSideBarContentWidth(),
        position: isSmallScreen ? 'relative' : 'fixed'
      }">
        <div class="side-bar-header position-relative d-flex align-items-center justify-content-center">
          <button @click="handleSideBar"
            :style="{ transform: showContent || (isSmallScreen && sideBarActive) ? '' : 'rotate(180deg)' }"
            role="button" aria-label="Fechar ou Abrir menu Lateral"
            class="position-absolute return-button border-0 bg-transparent active-route">
            <transition name="fade">
              <i v-if="sideBarActive" class="bi bi-arrow-left-square fs-5"></i>
            </transition>
          </button>
          <div class="image-container d-flex align-items-center justify-content-center">
            <transition name="fade">
              <img v-show="showImage" :src="this.getConsumerSettings?.settings.photo || ''" alt="Logo Empresa" />
            </transition>
          </div>
          <ul class="m-0 p-0 position-absolute" style="bottom: 20px">
            <li role="button" aria-label="Voltar para Menu Inicial" @click.stop="option('home')"
              class="router-option active-route d-flex align-items-center" :style="{
                width: getSideBarRouteOptionWidth(),
                color:
                  ((getType === 'student' || getType === 'tutor' || getType === 'teacher') && route.name === 'My Disciplines')
                    || ((getType === 'admin') && route.name === 'Home')
                    || (route.name === 'Disciplines')
                    ? userConfig?.settings.primary_color : '#787486'
              }">
              <i class="bi bi-house fs-5 me-4"></i>
              <transition name="fade">
                <p class="m-0 fs-6 p-0" v-show="showContent">Início</p>
              </transition>
            </li>
          </ul>
        </div>



        <div ref="scrollDiv" :style="{ marginLeft: marginLeft, height: sidebarBodyHeight }"
          class="side-bar-body flex-grow-1 d-flex justify-content-center align-items-start">
          <ul class="m-0 p-0">
            <li role="button" aria-label="Ir para tela de usuarios" @click.stop="option('users')"
              v-if="getType === 'admin' || getType === 'manager' && !disciplinesViews.includes(route.name)"
              class="router-option active-route my-4 d-flex align-items-center"
              :style="{ width: getSideBarRouteOptionWidth(), color: route.name === 'Users' ? userConfig?.settings.primary_color : '#787486' }">
              <i class="bi bi-people fs-5 me-4"></i>
              <transition name="fade">
                <p class="m-0 fs-6 p-0" v-show="showContent">Usuarios</p>
              </transition>
            </li>
            <li role="button" aria-label="Ir para tela de empresas" @click.stop="option('companies')"
              v-if="getType === 'admin'" class="router-option active-route my-4 d-flex align-items-center"
              :style="{ width: getSideBarRouteOptionWidth(), color: route.name === 'Companies' ? userConfig?.settings.primary_color : '#787486' }">
              <i class="bi bi bi-building fs-5 me-4"></i>
              <transition name="fade">
                <p class="m-0 fs-6 p-0" v-show="showContent">Empresas</p>
              </transition>
            </li>
            <li role="button" aria-label="Abrir menu Acadêmico" @click.stop="handleAcademicMenu"
              v-if="getType === 'manager' || getType === 'supervisor'"
              class="router-option active-route my-4 d-flex align-items-center"
              :style="{ width: getSideBarRouteOptionWidth(), color: isAcademicRoute ? userConfig?.settings.primary_color : '#787486' }">
              <i class="bi bi-mortarboard fs-5 me-4"></i>
              <transition name="fade">
                <div class="d-flex justify-content-between align-items-center w-100" v-if="showContent">
                  <div class="d-flex align-items-center gap-2">
                    <p class="m-0 fs-6 p-0">Acadêmico</p>
                    <BetaTag />
                  </div>
                  <i class="bi bi-chevron-down"
                    :style="{ transform: showAcademicMenu ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }"></i>
                </div>
              </transition>
            </li>

            <transition name="slide-left">
              <ul v-show="showAcademicMenu && showContent" class="m-0 p-0">
                <li role="button" @click.stop="option('organizations')"
                  class="router-option active-route my-2 d-flex align-items-center"
                  :style="{ paddingLeft: '50px', color: route.name === 'Academic Organizations' ? userConfig?.settings.primary_color : '#787486' }">
                  <p class="m-0 fs-6 p-0">Organização</p>
                </li>
                <li role="button" @click.stop="option('periods')"
                  class="router-option active-route my-2 d-flex align-items-center"
                  :style="{ paddingLeft: '50px', color: route.name === 'Academic Periods' ? userConfig?.settings.primary_color : '#787486' }">
                  <p class="m-0 fs-6 p-0">Período Letivo</p>
                </li>
                <li role="button" @click.stop="option('courses')"
                  class="router-option active-route my-2 d-flex align-items-center"
                  :style="{ paddingLeft: '50px', color: route.name === 'Academic Courses' ? userConfig?.settings.primary_color : '#787486' }">
                  <p class="m-0 fs-6 p-0">Curso</p>
                </li>
                <li role="button" @click.stop="option('curriculum-matrix')"
                  class="router-option active-route my-2 d-flex align-items-center"
                  :style="{ paddingLeft: '50px', color: route.name === 'Academic Curriculum Matrix' ? userConfig?.settings.primary_color : '#787486' }">
                  <p class="m-0 fs-6 p-0">Matriz Curricular</p>
                </li>
                <li role="button" @click.stop="option('classrooms')"
                  class="router-option active-route my-2 d-flex align-items-center"
                  :style="{ paddingLeft: '50px', color: route.name === 'Academic Classrooms' ? userConfig?.settings.primary_color : '#787486' }">
                  <p class="m-0 fs-6 p-0">Turma</p>
                </li>
                <li role="button" @click.stop="option('enrollments')"
                  class="router-option active-route my-2 d-flex align-items-center"
                  :style="{ paddingLeft: '50px', color: route.name === 'Academic Enrollments' ? userConfig?.settings.primary_color : '#787486' }">
                  <p class="m-0 fs-6 p-0">Matrícula</p>
                </li>
              </ul>
            </transition>

            <li role="button" aria-label="Abrir menu Financeiro" @click.stop="handleFinancialMenu"
              v-if="getType === 'manager' || getType === 'supervisor'"
              class="router-option active-route my-4 d-flex align-items-center"
              :style="{ width: getSideBarRouteOptionWidth(), color: isFinancialRoute ? userConfig?.settings.primary_color : '#787486' }">
              <i class="bi bi-cash-coin fs-5 me-4"></i>
              <transition name="fade">
                <div class="d-flex justify-content-between align-items-center w-100" v-if="showContent">
                  <div class="d-flex align-items-center gap-2">
                    <p class="m-0 fs-6 p-0">Financeiro</p>
                  </div>
                  <i class="bi bi-chevron-down"
                    :style="{ transform: showFinancialMenu ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }"></i>
                </div>
              </transition>
            </li>

            <transition name="slide-left">
              <ul v-show="showFinancialMenu && showContent" class="m-0 p-0">
                <li role="button" @click.stop="option('financial-students')"
                  class="router-option active-route my-2 d-flex align-items-center"
                  :style="{ paddingLeft: '50px', color: route.name === 'Financial Student' ? userConfig?.settings.primary_color : '#787486' }">
                  <p class="m-0 fs-6 p-0">Alunos</p>
                </li>
                <li role="button" @click.stop="option('bank-accounts')"
                  class="router-option active-route my-2 d-flex align-items-center"
                  :style="{ paddingLeft: '50px', color: route.name === 'Financial Bank Accounts' ? userConfig?.settings.primary_color : '#787486' }">
                  <p class="m-0 fs-6 p-0">Contas</p>
                </li>
                <li role="button" @click.stop="option('payment-methods')"
                  class="router-option active-route my-2 d-flex align-items-center"
                  :style="{ paddingLeft: '50px', color: route.name === 'Financial Payment Methods' ? userConfig?.settings.primary_color : '#787486' }">
                  <p class="m-0 fs-6 p-0">Métodos</p>
                </li>
                <li role="button" @click.stop="option('payment-plans')"
                  class="router-option active-route my-2 d-flex align-items-center"
                  :style="{ paddingLeft: '50px', color: route.name === 'Financial Payment Plans' ? userConfig?.settings.primary_color : '#787486' }">
                  <p class="m-0 fs-6 p-0">Planos</p>
                </li>
              </ul>
            </transition>
            <li role="button" aria-label="Ir para tela de Turma" @click.stop="option('class')"
              v-if="disciplinesViews.includes(route.name)"
              class="router-option active-route my-4 d-flex align-items-center"
              :style="{ width: getSideBarRouteOptionWidth(), color: route.name === 'Discipline Class' ? userConfig?.settings.primary_color : '#787486' }">
              <i class="bi bi-person-workspace fs-5 me-4"></i>
              <transition name="fade">
                <p class="m-0 fs-6 p-0" v-show="showContent">Turma</p>
              </transition>
            </li>
            <li role="button" aria-label="Ir para a tela de Notas" @click.stop="option('grades')"
              v-if="disciplinesViews.includes(route.name)"
              class="router-option active-route my-4 d-flex align-items-center"
              :style="{ width: getSideBarRouteOptionWidth(), color: route.name === 'Discipline Grades' ? userConfig?.settings.primary_color : '#787486' }">
              <i class="bi bi-person-lines-fill fs-5 me-4"></i>
              <transition name="fade">
                <p class="m-0 fs-6 p-0" v-show="showContent">Notas</p>
              </transition>
            </li>
            <li role="button" aria-label="Ir para a tela de Calendário" v-if="getType !== 'admin'"
              @click.stop="option('calendario')" class="router-option active-route my-4 d-flex align-items-center"
              :style="{ width: getSideBarRouteOptionWidth(), color: route.name === 'Calendar View' ? userConfig?.settings.primary_color : '#787486' }">
              <i class="bi bi-calendar fs-5 me-4"></i>
              <transition name="fade">
                <p class="m-0 fs-6 p-0" v-show="showContent">Calendário</p>
              </transition>
            </li>
            <li role="button" aria-label="Entrar em contato com o Tutor" @click.stop="option('chat')"
              v-if="getType === 'student' && this.getConsumerSettings.settings.tutoring_phone_number_enabled"
              class="router-option active-route my-4 d-flex align-items-center"
              :style="{ width: getSideBarRouteOptionWidth() }">
              <i class="bi bi-chat fs-5 me-4"></i>
              <transition name="fade">
                <p class="m-0 fs-6 p-0" v-show="showContent">Falar com Tutor</p>
              </transition>
            </li>
            <li role="button" aria-label="Entrar em contato com o Tutor" @click.stop="option('disciplines-feedback')"
              v-if="notAcademicRoles.includes(getType)" class="router-option active-route my-4 d-flex align-items-start"
              :style="{ width: getSideBarRouteOptionWidth() }">
              <i class="bi bi-star fs-5 me-4"></i>
              <transition name="fade">
                <p class="m-0 fs-6 p-0" v-show="showContent">Avaliações de Disciplinas</p>
              </transition>
            </li>
            <li role="button" aria-label="Acessar Mensagens" @click.stop="option('social-chat')"
              v-if="getType === 'student'"
              class="router-option active-route my-4 d-flex align-items-center"
              :style="{ width: getSideBarRouteOptionWidth(), color: route.name === 'Chat View' ? userConfig?.settings.primary_color : '#787486' }">
              <i class="bi bi-chat-text fs-5 me-4"></i>
              <transition name="fade">
                <p class="m-0 fs-6 p-0" v-show="showContent">Mensagens</p>
              </transition>
            </li>
            <li role="button" aria-label="Acessar Financeiro" @click.stop="option('student-financial')"
              v-if="getType === 'student'"
              class="router-option active-route my-4 d-flex align-items-center"
              :style="{ width: getSideBarRouteOptionWidth(), color: route.name === 'Financial Student' ? userConfig?.settings.primary_color : '#787486' }">
              <i class="bi bi-cash-coin fs-5 me-4"></i>
              <transition name="fade">
                <p class="m-0 fs-6 p-0" v-show="showContent">Financeiro</p>
              </transition>
            </li>
            <li role="button" aria-label="Abrir menu Comunicação" @click.stop="handleCommunicationMenu"
              v-if="getType !== 'student'"
              class="router-option active-route my-4 d-flex align-items-center"
              :style="{ width: getSideBarRouteOptionWidth(), color: isCommunicationRoute ? userConfig?.settings.primary_color : '#787486' }">
              <i class="bi bi-megaphone fs-5 me-4"></i>
              <transition name="fade">
                <div class="d-flex justify-content-between align-items-center w-100" v-if="showContent">
                  <p class="m-0 fs-6 p-0">Comunicação</p>
                  <i class="bi bi-chevron-down"
                    :style="{ transform: showCommunicationMenu ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }"></i>
                </div>
              </transition>
            </li>
            <transition name="slide-left">
              <ul v-show="showCommunicationMenu && showContent && getType !== 'student'" class="m-0 p-0">
                <li role="button" aria-label="Acessar Tela de Avisos" @click.stop="option('warning')"
                  v-if="warningRoutePermission.includes(getType)"
                  class="router-option active-route my-2 d-flex align-items-center"
                  :style="{ paddingLeft: '50px', color: route.name === 'Warning View' ? userConfig?.settings.primary_color : '#787486' }">
                  <p class="m-0 fs-6 p-0">Avisos</p>
                </li>
                <li role="button" aria-label="Acessar Tela de Chat" @click.stop="option('social-chat')"
                  class="router-option active-route my-2 d-flex align-items-center"
                  :style="{ paddingLeft: '50px', color: route.name === 'Chat View' ? userConfig?.settings.primary_color : '#787486' }">
                  <p class="m-0 fs-6 p-0">Chat</p>
                </li>
                <li role="button" aria-label="Acessar Tela de Email" @click.stop="option('email')"
                  v-if="emailRoutePermission.includes(getType)"
                  class="router-option active-route my-2 d-flex align-items-center"
                  :style="{ paddingLeft: '50px', color: route.name === 'Email View' ? userConfig?.settings.primary_color : '#787486' }">
                  <p class="m-0 fs-6 p-0">Email</p>
                </li>
              </ul>
            </transition>
          </ul>

        </div>
        <ul class=" m-0 p-0 side-bar-footer d-flex align-items-center justify-content-center">
          <li role="button" aria-label="Abrir menu de opções do Usuario"
            @click.stop="showContent ? handleDropUp() : handleSideBar()"
            :class="[showContent ? 'justify-content-between px-4' : 'justify-content-center', 'options-section w-100 router-option gap-1 w-100 active-route my-4 d-flex align-items-center']">
            <div :class="['avatar-container']">
              <AvatarCard :renderBorder="true" />
            </div>
            <transition name="fade">
              <div class="flex-grow-1 text-center user-name-wrapper" v-show="showContent">
                <p class="m-0 fs-6 p-0 user-name-text">
                  {{ getName }}
                </p>
              </div>
            </transition>
            <transition name="fade">
              <i v-show="showContent" class="bi bi-chevron-up"
                :style="{ transition: 'transform 0.5s', transform: showDropUp ? 'rotate(180deg)' : 'rotate(360deg)' }"></i>
            </transition>
          </li>
          <transition name="slide-up-down">
            <div @click.stop="handleDropUp" v-show="showDropUp && showContent"
              class="drop-up-container rounded-2 py-1 w-100 position-absolute" style="bottom: 60px">
              <ul class="mx-3 p-0 fs-6">
                <li role="button" aria-label="Sair do Sistema" @click.stop="logout()"
                  class="m-2 d-flex align-items-center justify-content-between active-route">
                  <p class="m-0">Sair</p> <i class="bi bi-box-arrow-right"></i>
                </li>
                <li role="button" aria-label="Ir para tela de Configurações" @click="option('settings')"
                  v-if="getType === 'manager' || getType === 'client'"
                  class="m-2 d-flex align-items-center justify-content-between active-route"
                  :style="{ color: route.name === 'Update Consumer Settings' ? userConfig?.settings.primary_color : '#787486' }">
                  <p class="m-0">Configurações</p> <i class="bi bi-gear"></i>
                </li>
                <li role="button" aria-label="Ir para tela de Alterar Senha" @click="option('change-password')"
                  class="m-2 d-flex align-items-center justify-content-between active-route"
                  :style="{ color: route.name === 'Change Password' ? userConfig?.settings.primary_color : '#787486' }">
                  <p class="m-0">Alterar senha</p> <i class="bi bi-key "></i>
                </li>
                <li role="button" aria-label="Ir para tela de Perfil" @click="option('user-profile')"
                  class="m-2 d-flex align-items-center justify-content-between active-route"
                  :style="{ color: route.name === 'Profile View' && route?.params?.id === userId ? userConfig?.settings.primary_color : '#787486' }">
                  <p class="m-0">Perfil</p> <i class="bi bi-people"></i>
                </li>
              </ul>
            </div>
          </transition>
        </ul>
      </div>
    </aside>
  </transition>
</template>

<script>
import router from '@/router'
import { mapGetters, useStore } from 'vuex';
import { toast } from "vue3-toastify";
import { useRoute } from "vue-router";
import { computed } from "vue";
import AvatarCard from '../cards/AvatarCard.vue';
import BetaTag from '../tags/BetaTag.vue';
import { redirectToUserProfile } from '@/utils/helpers';

export default {
  name: 'SideBarComponent',
  data() {
    return {
      observer: null,
      isSmallScreen: false,
      sideBarActive: false,
      sideBarCollapsed: false,
      showContent: false,
      showImage: false,
      showDropUp: false,
      route: useRoute(),
      store: useStore(),
      marginLeft: '0px',
      getName: computed(() => this.store.getters.getName),
      userWidth: computed(() => this.store.getters.getUserWidth),
      disciplinesViews: ['Discipline Class', 'Discipline Grades',
        'Discipline Material', 'Questionnaire Feedback',
        'Questionnaire Answers', 'Questionnaire Attempt',
        'Questionnaire', 'Assigment Attempt', 'Assigment Overview',
        'Attempt Feedback', 'Assignment Management'],
      notAcademicRoles: ['supervisor', 'manager'],
      warningRoutePermission: ['manager', 'tutor', 'teacher', 'supervisor'],
      emailRoutePermission: ['manager', 'supervisor', 'teacher', 'tutor'],
      configRoutes: ['Update Consumer Settings', 'Change Password'],
      userConfig: computed(() => this.store.getters.getConsumerSettings),
      sidebarBodyHeight: null,
      showAcademicMenu: false,
      showFinancialMenu: false,
      showCommunicationMenu: false
    }
  },

  components: {
    AvatarCard,
    BetaTag
  },

  computed: {
    ...mapGetters({
      getToken: 'getToken',
      getType: 'getType',
      getConsumerSettings: 'getConsumerSettings',
      getCompany: 'getCompany',
      fontMultiplier: 'acessibility/fontMultiplier',
      newLanguageState: 'acessibility/newLanguageState',
      userId: 'getId'
    }),
    isAcademicRoute() {
      return this.route.path.includes('/academic');
    },
    isFinancialRoute() {
      return this.route.path.includes('/financial');
    },
    isCommunicationRoute() {
      return ['Warning View', 'Chat View', 'Email View'].includes(this.route.name);
    }
  },

  watch: {
    userWidth() {
      this.checkScreenSize()
      this.$nextTick(() => {
        this.checkMarginLeftForItems();
      });
    },

    fontMultiplier() {
      this.$nextTick(() => {
        this.checkMarginLeftForItems();
      });
    },

    sideBarActive(newValue) {
      this.showContent = this.isSmallScreen && newValue
      if (this.showContent) {
        setTimeout(() => {
          this.showImage = true
        }, 300)

        return
      }
      this.showImage = false

    }, sideBarCollapsed(newValue) {
      this.showContent = !this.isSmallScreen && newValue
      if (this.showContent) {
        setTimeout(() => {
          this.showImage = true
        }, 300)

        return
      }
      this.showImage = false
    }
  },

  mounted() {
    const languageSelect = document.querySelector('.VIpgJd-ZVi9od-xl07Ob-lTBxed')
    if (languageSelect) {
      let selectText = languageSelect.textContent.trim();
      selectText = selectText.replace(/[^\w\s]/g, '').replace(/\s+/g, ' ');
      this.handleSideBarHeight(selectText);
    }

    this.startObserver()
    this.checkScreenSize();
    this.$nextTick(() => {
      this.checkMarginLeftForItems();
    });
  },

  methods: {
    checkMarginLeftForItems() {
      const el = this.$refs.scrollDiv
      if (el) return el.scrollHeight > el.clientHeight ? this.marginLeft = '11px' : this.marginLeft = '0px'
    },

    handleSideBarHeight(selectLanguageText) {
      const language = selectLanguageText;
      const replacedSpaces = language.replace(/\s+/g, '').trim();
      this.sidebarBodyHeight = replacedSpaces === 'Selecioneoidioma'
        ? 'calc(100vh - 360px)'
        : 'calc(100vh - 400px)';
    },

    stopObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    },


    startObserver() {
      const languageSelect = document.querySelector('.VIpgJd-ZVi9od-xl07Ob-lTBxed')
      if (languageSelect) {
        this.observer = new MutationObserver((mutationList) => {
          mutationList.forEach((mutation) => {
            if (mutation.type === "childList" || mutation.type === "characterData") {
              let selectText = languageSelect.textContent.trim();
              selectText = selectText.replace(/[^\w\s]/g, '').replace(/\s+/g, ' ');
              this.handleSideBarHeight(selectText);
            }
          })
        })

        this.observer.observe(languageSelect, {
          childList: true,
          characterData: true,
          subtree: true,
        })
      }
    },

    getSideBarBackGroundWidth() {
      let width;

      if (this.fontMultiplier > 1) {
        if (this.isSmallScreen) {
          width = '300px';
        } else if (this.sideBarCollapsed) {
          width = `calc(240px * ${this.fontMultiplier / 1.4})`;
        } else {
          width = `calc(70px * ${this.fontMultiplier / 1})`;
        }
      } else {
        if (this.isSmallScreen) {
          width = '240px';
        } else if (this.sideBarCollapsed) {
          width = '240px';
        } else {
          width = '70px';
        }
      }

      return width
    },

    getSideBarContentWidth() {
      let width;

      if (this.fontMultiplier > 1) {
        if (this.isSmallScreen) {
          width = '280px';
        } else if (this.sideBarCollapsed) {
          width = `calc(240px * ${this.fontMultiplier / 1.4})`;
        } else {
          width = `calc(70px * ${this.fontMultiplier / 1})`;
        }
      } else {
        if (this.isSmallScreen) {
          width = '240px';
        } else if (this.sideBarCollapsed) {
          width = '240px';
        } else {
          width = '70px';
        }
      }

      return width
    },

    getSideBarRouteOptionWidth() {
      let width;

      if (this.fontMultiplier > 1) {
        if (this.isSmallScreen) {
          width = '170px';
        } else if (this.sideBarCollapsed) {
          width = `calc(150px * ${this.fontMultiplier / 1.2} )`;
        } else {
          width = `calc(22px * ${this.fontMultiplier / 1} )`;
        }
      } else {
        if (this.showContent) {
          width = '180px';
        } else {
          width = '22px';
        }
      }

      return width
    },

    checkScreenSize() {
      this.isSmallScreen = this.userWidth <= 1280;
      if (this.isSmallScreen) {
        this.sideBarActive = false
        return
      }
      this.sideBarActive = true
    },

    handleSideBar() {
      if (this.isSmallScreen) {
        this.sideBarActive = !this.sideBarActive
        return
      }

      this.sideBarCollapsed = !this.sideBarCollapsed
    },

    handleDropUp() {
      this.showDropUp = !this.showDropUp
    },

    handleAcademicMenu() {
      if (!this.showContent) {
        this.handleSideBar();
        this.showAcademicMenu = true;
      } else {
        this.showAcademicMenu = !this.showAcademicMenu;
      }
    },

    handleFinancialMenu() {
      if (!this.showContent) {
        this.handleSideBar();
        this.showFinancialMenu = true;
      } else {
        this.showFinancialMenu = !this.showFinancialMenu;
      }
    },

    handleCommunicationMenu() {
      if (!this.showContent) {
        this.handleSideBar();
        this.showCommunicationMenu = true;
      } else {
        this.showCommunicationMenu = !this.showCommunicationMenu;
      }
    },

    async logout() {

      const payload = {
        userToken: this.getToken
      }

      try {
        await this.store.dispatch('logout', payload);

        router.push('/login');
      } catch (error) {
        console.log("Erro ao efetuar logout:", error)
      }
    },

    async option(option) {
      switch (option) {
        case 'home':
          if (this.getType == 'admin') {
            router.push('/home')
          } else if (this.getType == 'student' || this.getType == 'tutor' || this.getType == 'teacher') {
            router.push('/my/disciplines');
          } else {
            router.push('/disciplines');
          }
          break;
        case 'calendar':
          router.push('/calendar');
          break;
        case 'users':
          router.push('/users');
          break;
        case 'companies':
          router.push('/companies');
          break;
        case 'chat':
          const tutorNumber = this.getConsumerSettings.settings.tutoring_phone_number.replace(/[+\s()-]/g, '')
          window.open(`https://wa.me/55${tutorNumber}`, '_blank');
          break;
        case 'class':
          router.push(`/discipline/${this.$route.params.id}/class`);
          break;
        case 'grades':
          router.push(`/discipline/${this.$route.params.id}/grades`);
          break;
        case 'settings':
          router.push(`/consumers/settings`);
          break;
        case 'change-password':
          router.push(`/users/${this.getId}/change-password`);
          break;
        case 'warning':
          router.push('/notes')
          break;
        case 'calendario':
          router.push('/calendar')
          break;
        case 'user-profile':
          redirectToUserProfile(this.userId || null)
          break;
        case 'disciplines-feedback':
          router.push({ name: 'Disciplines Feedback' })
          break;
        case 'social-chat':
          router.push({ name: 'Chat View' })
          break;
        case 'email':
          router.push({ name: 'Email View' })
          break;
        case 'organizations':
          router.push({ name: 'Academic Organizations' });
          break;
        case 'periods':
          router.push({ name: 'Academic Periods' });
          break;
        case 'courses':
          router.push({ name: 'Academic Courses' });
          break;
        case 'curriculum-matrix':
          router.push({ name: 'Academic Curriculum Matrix' });
          break;
        case 'classrooms':
          router.push({ name: 'Academic Classrooms' });
          break;
        case 'enrollments':
          router.push({ name: 'Academic Enrollments' });
          break;
        case 'bank-accounts':
          router.push({ name: 'Financial Bank Accounts' });
          break;
        case 'payment-methods':
          router.push({ name: 'Financial Payment Methods' });
          break;
        case 'payment-plans':
          router.push({ name: 'Financial Payment Plans' });
          break;
        case 'student-financial':
        case 'financial-students':
          router.push({ name: 'Financial Student' });
          break;
      }
    },
  },

  destroyed() {
    this.stopObserver();
  }
}

</script>

<style scoped>
.avatar-container {
  width: 40px;
  transition: 0.5s;
}

.user-name-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-name-wrapper {
  width: 0px;
}

.menu-icon {
  top: 15px;
  left: 15px;
  background-color: #f5fafd;
  border: 1px solid black;
}

.side-bar-content {
  height: 100vh;
  transition: 0.5s;
}

.side-bar {
  transition: 0.5s;
  /* min-height: 100dvh; */
  height: 100%;
  border-right: 1px solid #DBDBDB;
  cursor: pointer;
  background-color: var(--blue-4);
}

.side-bar-header {
  height: 300px;
  border-bottom: 1px solid #DBDBDB;
}

.image-container {
  width: 100%;
  height: 130px;
}

.image-container img {
  width: 130px;
  height: 100%;
  object-fit: contain;
}

.return-button {
  top: 15px;
  right: 20px;
}

.side-bar-body {
  overflow-y: auto;
  overflow-x: hidden;
}

.side-bar-body::-webkit-scrollbar {
  width: 11px;
}

.side-bar-body::-webkit-scrollbar-track {
  background: var(--blue-4);
  border-radius: 20px;
}

.side-bar-body::-webkit-scrollbar-thumb {
  width: 11px;
  background-color: #1B557A24;
  border-radius: 20px;
}


.router-option {
  transition: 0.5s;
}

.active-route {
  color: #787486;
}

.disable-route {
  color: #7874868F;
}

.side-bar-footer {
  height: 60px;
}

.drop-up-container {
  border: 1px solid #DBDBDB;
  background-color: var(--blue-4);
}

li {
  list-style-type: none;
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.3s ease-out;
  transform: translateX(0);
  opacity: 1;
  max-height: 300px;
  /* Adjust based on content */
}

.slide-left-enter-from,
.slide-left-leave-to {
  transform: translateX(-20px);
  opacity: 0;
  max-height: 0;
}
</style>
